import { Reducer } from 'redux'

import ActionTypes from '../../constants/action-types'
import BaseStateDefault from '../../constants/state'
import IMetadataState from '../../interfaces/states/metadata'

const initialState: IMetadataState = {
  ...BaseStateDefault
}

const reducer: Reducer<any> = (
  state: IMetadataState = initialState,
  action: any
): IMetadataState => {
  switch (action.type) {
    case ActionTypes.Metadata.METADATA_CREATE_REQUEST:
    case ActionTypes.Metadata.METADATA_UPDATE_REQUEST:
    case ActionTypes.Metadata.METADATA_DELETE_REQUEST:
    case ActionTypes.Metadata.METADATA_GET_LIST_REQUEST: {
      return {
        ...state,
        requesting: true,
        error: undefined
      }
    }
    case ActionTypes.Metadata.METADATA_CREATE_FAILED:
    case ActionTypes.Metadata.METADATA_UPDATE_FAILED:
    case ActionTypes.Metadata.METADATA_DELETE_FAILED:
    case ActionTypes.Metadata.METADATA_GET_LIST_FAILED: {
      return {
        ...state,
        requesting: false,
        error: action.payload.error
      }
    }
    case ActionTypes.Metadata.METADATA_GET_LIST_SUCCESS: {
      const { list, paging } = action.payload
      return {
        ...state,
        requesting: false,
        list,
        paging
      }
    }
    case ActionTypes.Metadata.METADATA_CREATE_SUCCESS: {
      const { data } = action.payload
      return {
        ...state,
        requesting: false,
        list: [data, ...(state.list || [])]
      }
    }
    case ActionTypes.Metadata.METADATA_UPDATE_SUCCESS: {
      const { data } = action.payload
      return {
        ...state,
        requesting: false,
        list: state.list?.map((l) => (l.id === data.id ? data : l))
      }
    }
    case ActionTypes.Metadata.METADATA_DELETE_SUCCESS: {
      const { id } = action.payload
      return {
        ...state,
        requesting: false,
        list: state.list?.filter((l) => l.id !== id)
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
